import StekzPaletteProvider from "./palette-provider";
import StekzContextPadProvider from "./context-pad-provider";
import StekzReplaceMenuProvider from "./replace-menu-provider";

export default {
    __init__: [
        "StekzPaletteProvider",
        "StekzContextPadProvider",
        "StekzReplaceMenuProvider",
    ],
    StekzPaletteProvider: ["type", StekzPaletteProvider],
    StekzContextPadProvider: ["type", StekzContextPadProvider],
    StekzReplaceMenuProvider: ["type", StekzReplaceMenuProvider],
};
